import { Component } from '@angular/core';

import { MatDialog } from '@angular/material';

import { Material } from '../../_models/material';
import { ConfirmComponent } from '../../shared/confirm/confirm.component';
import { MaterialsService } from '../../shared/materials.service';
import { ModifyMaterialComponent } from './modify-material.component';

@Component({
  moduleId: module.id,
  templateUrl: 'manage-materials.component.html',
  styleUrls: ['manage-materials.component.css']
})

export class ManageMaterialsComponent {
  searchMaterialsInput = '';

  constructor(public manageMaterialsService: MaterialsService, public dialog: MatDialog) {}

  goTo(location: string): void {
    window.open(location);
  }

  confirmDelete(material: Material) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: { confirmMessage: 'Are you sure you want to delete this material? It will be unavailable for all stores.' },
      disableClose: true,
      width: '400px',
    });
    return dialogRef.afterClosed().subscribe((confirm: boolean) => {
      if (confirm) {
        this.manageMaterialsService.removeMaterial(material);
      }
    });
  }

  formatDateString(object_to_check: any, date_name: string): void {
    if (object_to_check[date_name]) {
      object_to_check[date_name] = new Date(object_to_check[date_name]).toISOString().split('T')[0];
    } else {
      object_to_check[date_name] = null;
    }
  }

  newMaterial() {
    const dialogRef = this.dialog.open(ModifyMaterialComponent, {
      width: '600px',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.handleMaterialOutput(result);
    });
  }

  handleMaterialOutput(materialFormData: any, materialID: any = null): void {
    if (materialFormData) {
      const data = materialFormData['material'];
      const file = materialFormData['file'];
      // If an attribute with file in our data, upload the new file to our dataset
      this.formatDateString(data, 'end_date');
      this.formatDateString(data, 'start_date');
      if (materialID) {
        this.manageMaterialsService.patchMaterial(materialID, data, file);
      } else {
        this.manageMaterialsService.postMaterial(data, file);
      }
    }
  }

  modifyMaterial(material: Material) {
    const dialogRef = this.dialog.open(ModifyMaterialComponent, {
      width: '600px',
      data: { material: material }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.handleMaterialOutput(result, material.id);
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/hq/materials/manage-materials.component.ts